export default "__VITE_ASSET__DbRmbURn__"